import { render } from "./ActivateTrackpoint.vue?vue&type=template&id=5457ea62&scoped=true"
import script from "./ActivateTrackpoint.vue?vue&type=script&lang=ts"
export * from "./ActivateTrackpoint.vue?vue&type=script&lang=ts"

import "./ActivateTrackpoint.vue?vue&type=style&index=0&id=5457ea62&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5457ea62"

export default script